import httpService from "./httpService";

export default {

    findAll(example) {
        return httpService.get("/docRelation", {params: example});
    },
}


// WEBPACK FOOTER //
// ./src/services/docRelationService.js